import FrontendLayout from "@/Frontend/Layouts/FrontendLayout";
import PageHeading from "@/Frontend/Components/PageHeading";
import React from "react";
import Lottie from "lottie-react";
import SuccessAnimation from "../../Lottie/success.json";
import translate from "@/utils/translate";
import { Link } from "@inertiajs/react";
import BioneMeta from "@/utils/BioneMeta";

export default function OrderSuccess({
    order,
    meta_tags,
    tagline,
    site_name,
}) {
    BioneMeta(tagline, "", meta_tags, "", "", site_name);

    const pageHeaderData = {
        title: "Order Success",
        breadcrumb: [
            { label: "Home", url: "/" },
            {
                label: "Order Success",
                url: null,
            },
        ],
    };

    return (
        <FrontendLayout>
            <PageHeading
                data={pageHeaderData}
                bgSrc={"/static/page_heading.jpg"}
            />

            <div className="container booking-success-page text-center">
                <div className="row justify-content-center">
                    <div className="col-md-6">
                        <div className="card booking-card p-4">
                            <div className="card-body">
                                <div className="booking-success-icon">
                                    <Lottie
                                        animationData={SuccessAnimation}
                                        loop={true}
                                    />
                                </div>

                                <h1 className="my-4">
                                    {translate(
                                        "Your Order Has Been Successfully Placed"
                                    )}
                                    !
                                </h1>

                                <p className="mb-4">
                                    {translate("Your order id is")} #
                                    {order.order_number}
                                </p>

                                <div className="d-flex justify-content-center gap-2 flex-wrap">

                                    <Link
                                        href={route("orders")}
                                        className="btn btn-outline-secondary"
                                    >
                                        {translate("My Orders")}
                                    </Link>

                                    <a
                                        href={`/user/download-invoice/${order.id}`}
                                        className="btn booking-btn-custom"
                                    >
                                        {translate("Download Invoice")}
                                    </a>

                                    <Link
                                        href="/shop"
                                        className="btn btn-outline-secondary"
                                    >
                                        {translate("Continue Shopping")}
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </FrontendLayout>
    );
}